import { render, staticRenderFns } from "./InPageNavigation.vue?vue&type=template&id=4e71bf19"
import script from "./InPageNavigation.vue?vue&type=script&lang=js"
export * from "./InPageNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports